import React, { useState, useEffect, useRef } from 'react';
import './QuotesOverlay.css';

function QuotesOverlay({ quotes }) {
  const [floatingQuotes, setFloatingQuotes] = useState([]);
  const animationRef = useRef(null);
  const containerRef = useRef(null);
  
  useEffect(() => {
    if (quotes.length === 0) return;
    
    const latestQuote = quotes[0];
    
    const quoteExists = floatingQuotes.some(q => q.id === latestQuote.id);
    
    if (!quoteExists) {
      const newFloatingQuote = createFloatingQuote(latestQuote);
      
      setFloatingQuotes(prev => [...prev, newFloatingQuote]);
    }
    
    if (floatingQuotes.length > 8) {
      setFloatingQuotes(prev => prev.slice(-8));
    }
  }, [quotes, floatingQuotes]);
  
  useEffect(() => {
    if (floatingQuotes.length === 0 && quotes.length > 0) {
      const quotesToShow = quotes.slice(0, 8);
      
      const initialFloatingQuotes = quotesToShow.map((quote) => 
        createFloatingQuote(quote)
      );
      
      setFloatingQuotes(initialFloatingQuotes);
    }
  }, [quotes]);
  
  const createFloatingQuote = (quote) => {
    const posX = Math.random() * 80 + 10;
    const posY = Math.random() * 80 + 10;
    const fontSize = 18 + Math.floor(Math.random() * 12);
    const opacity = 0.2 + Math.random() * 0.3;
    
    const velocityX = (Math.random() - 0.5) * 0.15;
    const velocityY = (Math.random() - 0.5) * 0.15;
    
    const quoteDate = quote.date ? new Date(quote.date) : null;
    const formattedDate = quoteDate ? 
      quoteDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }) : '';
    
    return {
      id: quote.id,
      text: quote.text,
      date: formattedDate,
      x: posX,
      y: posY,
      velocityX: velocityX,
      velocityY: velocityY,
      fontSize: fontSize,
      opacity: opacity
    };
  };
  
  useEffect(() => {
    if (floatingQuotes.length === 0) return;
    
    const moveQuotes = () => {
      setFloatingQuotes(prev => {
        return prev.map(quote => {
          let newX = quote.x + quote.velocityX;
          let newY = quote.y + quote.velocityY;
          let newVelocityX = quote.velocityX;
          let newVelocityY = quote.velocityY;
          
          const estimatedWidth = (quote.text.length * quote.fontSize) / 20;
          
          if (newX < 0) {
            newX = 0;
            newVelocityX = Math.abs(newVelocityX);
          } else if (newX > 100 - estimatedWidth / 100) {
            newX = 100 - estimatedWidth / 100;
            newVelocityX = -Math.abs(newVelocityX);
          }
          
          if (newY < 0) {
            newY = 0;
            newVelocityY = Math.abs(newVelocityY);
          } else if (newY > 95) {
            newY = 95;
            newVelocityY = -Math.abs(newVelocityY);
          }
          
          return {
            ...quote,
            x: newX,
            y: newY,
            velocityX: newVelocityX,
            velocityY: newVelocityY
          };
        });
      });
      
      animationRef.current = requestAnimationFrame(moveQuotes);
    };
    
    animationRef.current = requestAnimationFrame(moveQuotes);
    
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [floatingQuotes.length]);
  
  return (
    <div className="quotes-overlay-transparent" ref={containerRef}>
      {floatingQuotes.map(quote => (
        <div 
          key={quote.id} 
          className="floating-quote"
          style={{
            left: `${quote.x}%`,
            top: `${quote.y}%`,
            fontSize: `${quote.fontSize}px`,
            opacity: quote.opacity
          }}
        >
          <div className="quote-text">"{quote.text}"</div>
          <div className="quote-date">{quote.date}</div>
        </div>
      ))}
    </div>
  );
}

export default QuotesOverlay;
